/**
 * The width below which the portal treats the screen as a phone — where the
 * dashboard narrows its week to one day and the hours editor opens as a list.
 * One constant so those screens cannot disagree about what a phone is.
 *
 * Its own module rather than an export of `useMediaQuery.js`, which tests
 * replace wholesale with a stub that has no constants on it.
 */
export const PHONE_QUERY = '(max-width: 720px)';
